export default "__VITE_ASSET__CqvG3XU___"